//文字コードはutf-8

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const IS_SP = window.matchMedia('(max-width: 999px)').matches;

const REGION_COUNT = 6;
const COLLAGE_AUTOPLAY = true;
const SWITCH_MIN_DELAY = 1500; // ms
const SWITCH_MAX_DELAY = 3000; // ms
// CSS 側のクロスフェード時間（_anniversary.scss の `.item { transition: opacity 3.5s ... }` と一致させる）。
// この時間が経過するまでは同じ領域を再度切り替え対象にしない（中途半端な opacity の重なりで空白が出るのを防ぐ）。
const FADE_DURATION = 3500; // ms
const RETRY_DELAY = 200; // ms（全領域がフェード中だった場合のリトライ間隔）

export function initGridScroll() {
    const $cols = $('[data-grid-scroll]');
    if (!$cols.length) return;

    if (REDUCED_MOTION) {
        // 静的に重ねて表示（複製・クロスフェードなし）
        return;
    }

    if (IS_SP) {
        initGridCollage();
        return;
    }

    // --- PC: 3 カラム縦無限スクロール ---
    $cols.each(function () {
        const $col = $(this);
        const $items = $col.children();
        if ($items.length < 2) return;

        // 同一セットを 1 回だけ複製（CSS keyframe は 50% 単位でループ）
        $items.clone(true)
            .attr('aria-hidden', 'true')
            .addClass('is-gridScrollClone')
            .appendTo($col);

        // CSS 側のアニメーションを発火
        $col.addClass('is-gridScroll');
    });
}

// --- SP: 重ねコラージュのランダムクロスフェード ---
function initGridCollage() {
    const grid = document.querySelector('.topGridSlide__grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.topGridSlide__grid__col .item'));
    if (!items.length) return;

    // 先にデコードしておき、初回フェードイン時のデコード待ちによるカクつきを防ぐ
    items.forEach((el) => {
        const img = el.querySelector('img');
        if (img && typeof img.decode === 'function') {
            img.decode().catch(() => {});
        }
    });

    // DOM 順（カラム 1→2→3）で 6 領域へ振り分け（CSS の (($i-1) % 6)+1 と一致）
    const regions = Array.from({ length: REGION_COUNT }, () => []);
    items.forEach((el, i) => regions[i % REGION_COUNT].push(el));

    // 初期表示：各領域の先頭（＝1 カラム目の画像）を表示
    const current = regions.map((imgs) => {
        imgs.forEach((el, j) => el.classList.toggle('is-active', j === 0));
        return 0;
    });

    // JS 起動を通知して CSS フォールバック（先頭強制表示）を解除
    grid.classList.add('is-ready');

    // レイアウト調整中は自動切り替えを止め、初期表示（各領域 1 枚）で固定する
    if (!COLLAGE_AUTOPLAY) return;

    // 2 枚以上ある領域だけが差し替え対象
    const switchable = regions.reduce((acc, imgs, r) => {
        if (imgs.length >= 2) acc.push(r);
        return acc;
    }, []);
    if (!switchable.length) return;

    const randInt = (max) => Math.floor(Math.random() * max);

    // 領域ごとのクロスフェード進行中フラグ。
    // 進行中の領域を再度切り替え対象に選んでしまうと、3 枚目以降が中途半端な
    // opacity で重なって合計透明度が 1 を下回り、その領域が一瞬空白に見える。
    const transitioning = new Array(REGION_COUNT).fill(false);

    const step = () => {
        // クロスフェード未完了の領域は除外して候補を作る
        const candidates = switchable.filter((r) => !transitioning[r]);
        if (!candidates.length) {
            // 全ての領域がフェード中の場合は少し待ってからリトライ
            setTimeout(step, RETRY_DELAY);
            return;
        }

        const r = candidates[randInt(candidates.length)];
        const imgs = regions[r];
        const prev = current[r];

        // 現在と違う 1 枚をランダムに選ぶ
        let next;
        do {
            next = randInt(imgs.length);
        } while (next === prev);

        transitioning[r] = true;
        imgs[prev].classList.remove('is-active');
        imgs[next].classList.add('is-active');
        current[r] = next;

        setTimeout(() => {
            transitioning[r] = false;
        }, FADE_DURATION);

        const delay = randInt(SWITCH_MAX_DELAY - SWITCH_MIN_DELAY) + SWITCH_MIN_DELAY;
        setTimeout(step, delay);
    };

    setTimeout(step, SWITCH_MIN_DELAY);
}
